import RemindersContainer from './reminders-container';

export default RemindersContainer;
